import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './IconList.style'
import RichText from '../RichText'

const IconListContentful = ({ data, t }) => {
  const { title, disclaimer, listItems } = data
  const styles = useStyles()

  const listItemContent = JSON.parse(listItems.raw)

  return (
    <Box className={styles.root}>
      <Typography variant="h4" className={styles.iconListTitle}>
        {title}
      </Typography>
      <Box className={styles.iconList}>
        {listItemContent.content.map((content, index) => {
          if (content.nodeType === 'embedded-asset-block')
            return (
              <div className={styles.listItem}>
                <RichText
                  variant="body1"
                  document={listItemContent.content[index + 1]}
                  references={listItems.references}
                />
              </div>
            )
          return <></>
        })}
        <Typography className={styles.footerText}>{disclaimer.text}</Typography>
      </Box>
    </Box>
  )
}

export default IconListContentful
